import { Anchor, Flex, spaceMixin, token } from '@zillow/constellation';
import Image from 'next/image';
import styled from 'styled-components';

export const StyledHorizontalCard = styled(Anchor)`
  display: flex;
  width: 100%;
  align-items: center;
  text-decoration: none;
  background-color: ${(props) => token(`colors.${props.$backgroundColor}`)};
  border: 1px solid ${token('colors.gray300')};
  border-radius: 4px;
  padding: ${spaceMixin('sm')};
  margin: ${spaceMixin('xs')} 0;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const StyledIconWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;

  svg {
    height: 21px;
    width: 21px;
    color: ${(props) => token(`colors.${props.$color}`)};
  }
`;

export const StyledImage = styled(Image)`
  border-radius: 4px;
  object-fit: cover;
  min-width: 40px;
`;

export const StyledContentWrapper = styled.div`
  margin-left: ${spaceMixin('sm')};
  min-width: 0;
`;

export const StyledActionIndicatorWrapper = styled(Flex)`
  margin-left: auto;
  padding-left: 8px;

  svg {
    height: 21px;
    width: 21px;
    color: ${(props) => token(`colors.${props.$color}`)};
  }
`;
